// @flow

import { type EdgeIo } from '../../types/types.js'

export function makeReactNativeIo (): Promise<EdgeIo> {
  throw new Error('This function only works on React Native')
}
